import React, { PropTypes } from 'react';
import Modal from '../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput } from '../Form';
import { inject, observer } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import moment from 'moment';
import { token } from '../../libs/localStorage';
import FormMultiSelectInput from '../FormMultiSelectInput';
import { tripApi } from '../../actions/api';

@inject('ticketStore', 'workOrderStore', 'stationStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'rolePermissionStore', 'serverStore', 'folderStore', 'tripStore', 'parameterStore')
@observer
export default class TripStationAdd extends React.Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = this.props.slug ? '/' + this.props.slug : `/monitoring/trip/map/${this.props.params && this.props.params.id && this.props.params.id[0]}/view`;
  // slug = this.props.slug ? '/' + this.props.slug : '/monitoring/work_order/tabular';


  @observable stations = [];
  @observable item = {
    station_id: null,
    duration: ''
  };

  @observable multiUserOptions = [];
  @action onChangeDuration = e => this.item.duration = e.target.value;


  componentDidMount() {
    const { params: { id }, stationStore, parameterStore, ticketStore, workOrderStore } = this.props;
    if (!parameterStore.items.length) parameterStore.fetchItems();
    if (!stationStore.items.length) stationStore.fetchItems();
    if (!ticketStore.items.length) ticketStore.fetchItems();
    if (!workOrderStore.items.length) workOrderStore.fetchItems()

    const ticketStationIds = new Set(ticketStore.filteredTickets2.map(ticket => Number(ticket.station_id)));
    const workOrderStationIds = new Set(workOrderStore.filteredWorkOrders2 && workOrderStore.filteredWorkOrders2.map(workOrder => Number(workOrder.station && workOrder.station[0].id)));

    const combinedStationIds = new Set([...ticketStationIds, ...workOrderStationIds]);

    this.stations = stationStore.items
      ? stationStore.items
        .filter(station => combinedStationIds.has(station.id)) 
        .sort((a, b) => a.name.localeCompare(b.name)) 
      : [];

  }

  @action onChangeStationFilter = (e) => {
    const stationId = e.target.value;
    this.item.station_id = stationId;
  }

  handleSave = async (e) => {
    const { tripStore } = this.props
    e.preventDefault();
    const { station_id, duration } = this.item
    const { params: { id } } = this.props
    let prevStationId = id && id[1] != 'add' && id[1]
    tripStore.updateStationData({ station_id, duration, prevStationId });
    await tripStore.fetchItems()
    this.context.router.push(`/monitoring/trip/map/${id[0]}/view`);
  };

  render() {
    const { stationStore, userStore, ticketStore, rolePermissionStore, serverStore, folderStore } = this.props;
    if (serverStore.items.length == 0) serverStore.fetchItems()
    if (folderStore.items.length == 0) folderStore.fetchItems()
    const station = stationStore.findById(this.item.station_id);

    return (
      <Modal slug={this.slug} title='Add Trip' isSaving={ticketStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={'Duration'} value={this.item.duration} onChange={e => this.onChangeDuration(e, 'duration')} />
            {<SelectInput
              label={'Station'}
              value={this.item.station_id}
              options={this.stations}
              filterOptions={stationStore.filterStations}
              onChange={this.onChangeStationFilter}
              fields={{
                label: 'name',
                value: 'id',
              }}
            />}


          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Trips/TripStationAdd.js